import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="assignment-resolver"
export default class extends Controller {
  static targets = ["checkbox", "userLink"]

  connect() {
    this.updateLinks()
  }

  updateLinks() {
    const shouldMarkResolved = this.checkboxTarget.checked

    this.userLinkTargets.forEach(link => {
      const url = new URL(link.href)

      if (shouldMarkResolved) {
        url.searchParams.set('mark_resolved', 'true')
      } else {
        url.searchParams.delete('mark_resolved')
      }

      link.href = url.toString()
    })
  }
}
